<template>
  <div>
    <monitoring-report
      ref="monitoringReport"
      type="unmonitored"
      @add="addMonitoring()"
    />
    <check-monitoring
      ref="checkMonitoring"
      @delete="deleteMonitoring()"
    />
  </div>
</template>

<script>
import MonitoringReport from '@/views/pages/monitoring-report/MonitoringReport.vue'
import CheckMonitoring from '@/views/pages/org-monitoring/components/check-monitoring/CheckMonitoring.vue'

export default {
  name: 'CheckMonitoringView',
  components: {
    CheckMonitoring,
    MonitoringReport,
  },
  methods: {
    addMonitoring() {
      console.log('add')
      this.$refs.checkMonitoring.$refs.LTable.refetchData()
    },
    deleteMonitoring() {
      console.log('delete')
      this.$refs.monitoringReport.$refs.LTable.refetchData()
    },
  },
}
</script>

<style scoped>

</style>
